import { render, staticRenderFns } from "./paper-refers.vue?vue&type=template&id=67bd3bef&scoped=true&"
import script from "./paper-refers.vue?vue&type=script&lang=js&"
export * from "./paper-refers.vue?vue&type=script&lang=js&"
import style0 from "./paper-refers.vue?vue&type=style&index=0&id=67bd3bef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd3bef",
  null
  
)

export default component.exports